import React from 'react';
import { Page } from '../Page';
export function PageGLP1Overview2() {
  return <Page pageNumber={3} variant="light" data-id="element-972">
      <div className="flex flex-col h-full" data-id="element-973">
        {/* Image at Top */}
        <div className="h-[340px] overflow-hidden mb-10" data-id="element-974">
          <img src="https://cdn.magicpatterns.com/uploads/sSsZcR853PsxEnjk3uuBHM/glp1_transparent.png" alt="GLP-1 vial and syringe system" className="w-full h-full object-contain" data-id="element-975" />
        </div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-2 gap-10 flex-1" data-id="element-976">
          {/* Left Column */}
          <div className="space-y-5" data-id="element-977">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-978">
              The signals that tell you you're full actually stick around,
              instead of disappearing quickly and leaving you thinking about
              your next meal. You feel full sooner. You stay full longer. And
              over time, food starts to take up less space in your day.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-979">
              You're not constantly planning your next meal or fighting off
              cravings. Eating becomes more straightforward, more controlled,
              and a lot less mental.
            </p>
            <p className="text-sm text-[#1F1F1F] leading-[1.8] font-medium italic" data-id="element-980">
              That's the shift.
            </p>
          </div>

          {/* Right Column - The Gut Effect */}
          <div data-id="element-981">
            <h2 className="text-2xl font-serif text-[#1F1F1F] leading-tight mb-2" data-id="element-982">
              The Gut Effect
            </h2>
            <div className="w-10 h-0.5 bg-tealslate mb-4" data-id="element-983" />
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-984">
              One of the first things this medication does is slow down how
              quickly food moves through your stomach. Digestion takes longer,
              which means nutrients are released more gradually and your blood
              sugar stays more stable after meals. That stability plays a big
              role in how you feel. Instead of getting hungry again shortly
              after eating, you stay physically full for longer.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mt-4" data-id="element-985">
              This is where medications like semaglutide and tirzepatide are
              especially effective. It's also why many people notice they
              naturally start eating smaller portions without trying and still
              feel satisfied for hours afterward.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}